import { LayerType } from "./layer.model"


export enum EffectsType {
  Blur = 'Blur',
  Texture = 'Texture',
  Outline = 'Outline',
  Sepia = 'Sepia',
  DropShadow = 'Drop Shadow',
  Noise = 'Noise'
}

export type UIEffect = LayerType | EffectsType

export interface UIEffectItem {
  label: string
  image: string
  type: UIEffect
  isLayer: boolean
}

export const uiEffects: UIEffectItem[] = [
  {
    label: 'Buildings',
    image: 'assets/effects/buildings.jpg',
    type: LayerType.Buildings,
    isLayer: true
  },
  {
    label: 'Material Overlay',
    image: 'assets/effects/materialBalls.jpg',
    type: LayerType.MaterialOverlay,
    isLayer: true
  },
  {
    label: 'Contour',
    image: 'assets/effects/contourLines.jpg',
    type: LayerType.Contour,
    isLayer: true
  },
  {
    label: 'Water',
    image: 'assets/effects/water.jpg',
    type: LayerType.Water,
    isLayer: true
  },
  {
    label: 'Zones',
    image: 'assets/effects/borders.jpeg',
    type: LayerType.Zones,
    isLayer: true,
  },
  {
    label: 'Color Overlay',
    image: 'assets/effects/colorShift.jpg',
    type: LayerType.Overlay,
    isLayer: true
  },
  {
    label: 'POI Glow',
    image: 'assets/effects/poiGlow.png',
    type: LayerType.POIGlow,
    isLayer: true
  },
  {
    label: 'Blur',
    image: 'assets/effects/bluredImage.jpeg',
    type: EffectsType.Blur,
    isLayer: false,
  },
  {
    label: 'Sepia',
    image: 'assets/effects/sepia.jpg',
    type: EffectsType.Sepia,
    isLayer: false,
  },
  {
    label: 'Roads Overlay',
    image: 'assets/effects/roadMap.jpg',
    type: LayerType.Roads,
    isLayer: true
  },
  {
    label: 'Textures',
    image: 'assets/effects/texture.jpg',
    type: EffectsType.Texture,
    isLayer: false,
  },
  {
    label: 'Outline',
    image: 'assets/effects/outline.jpg',
    type: EffectsType.Outline,
    isLayer: false,
  },
  {
    label: 'Drop Shadow',
    image: 'assets/effects/dropShadow.jpg',
    type: EffectsType.DropShadow,
    isLayer: false,
  },
  {
    label: 'Grid Lines',
    image: 'assets/effects/gridLines.jpg',
    type: LayerType.GridLines,
    isLayer: true,
  },
  {
    label: 'Noise',
    image: 'assets/effects/noise.jpeg',
    type: EffectsType.Noise,
    isLayer: false,
  },
  // {
  //   label: 'Height Glow',
  //   image: 'assets/effects/roadMap.jpg',
  //   type: LayerType.HeightGlow,
  //   isLayer: true
  // },
].sort((a, b) => a.label.localeCompare(b.label))

